import axios from "axios"
import ROOTURL from "./ROOTURL"
import {BUSINESSID} from "./ROOTURL"

export const getBusinessLocations = () =>
  axios.get(`${ROOTURL}/businesses/${BUSINESSID}/blocations`)
